/* eslint-disable consistent-return */
import { mergeWith, isArray } from 'lodash'
import { schema } from 'normalizr'

export const entityKeys = {
  customer: 'customer',
  reward: 'reward',
  promotion: 'promotion',
  earningHistory: 'earningHistory',
  redemptionHistory: 'redemptionHistory',
  communicationHistory: 'communicationHistory',
  giftHistory: 'giftHistory',
  allowanceHistory: 'allowanceHistory',
  post: 'post',
  customerGiftIssued: 'customerGiftIssued',
  customerGiftRedeemed: 'customerGiftRedeemed',
  customerAllowanceIssued: 'customerAllowanceIssued',
  customerAllowanceRedeemed: 'customerAllowanceRedeemed',
}

export const getEntitiesSelector = key => state => state?.entities?.[key] ?? {}
export const getEntitySelector = (key, id) => state => state?.entities?.[key]?.[id] ?? {}

const createEntity = (name, structure = {}, options = {}) =>
  new schema.Entity(name, structure, { idAttribute: '_id', ...options })

// schemas
const rewardEntity = createEntity(entityKeys.reward)
const promotionEntity = createEntity(entityKeys.promotion)

export const customerEntity = createEntity(entityKeys.customer, {
  availableRewards: [rewardEntity],
  eligiblePromotions: [promotionEntity],
})

export const earningHistoryEntity = createEntity(entityKeys.earningHistory)
export const redemptionHistoryEntity = createEntity(entityKeys.redemptionHistory)
export const commHistoryEntity = createEntity(entityKeys.communicationHistory)
export const giftHistoryEntity = createEntity(entityKeys.giftHistory)
export const allowanceHistoryEntity = createEntity(entityKeys.allowanceHistory)
export const postEntity = createEntity(entityKeys.post)
export const customerGiftIssuedEntity = createEntity(entityKeys.customerGiftIssued)
export const customerGiftRedeemedEntity = createEntity(entityKeys.customerGiftRedeemed)
export const customerAllowanceIssuedEntity = createEntity(entityKeys.customerAllowanceIssued)
export const customerAllowanceRedeemedEntity = createEntity(entityKeys.customerAllowanceRedeemed)

// action
const UPDATE_ENITITIES = 'UPDATE_ENITITIES'
export const updateEntities = (payload = {}) => ({ type: UPDATE_ENITITIES, payload })

function customizer(objValue, srcValue) {
  if (isArray(objValue)) {
    return srcValue
  }
}

// reducer
export function entities(state = {}, action) {
  if (action.type === UPDATE_ENITITIES) {
    return mergeWith({}, state, action.payload, customizer)
  }
  return state
}
